const accessPlans = {

    ACTIVE_PLAN: { name: 'Active Plan', path: '/plans/active-plan' },
    FUTURE_PLAN: { name: 'Future Plan', path: '/plans/future-plan' },
    PLAN_HISTORY: { name: 'Plan History', path: '/plans/plan-history' },

}

export default accessPlans;
